module.exports = __webpack_public_path__ + "img/XXK.d3893b45.png";